<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card m-b-30">
                <div class="card-body">
                    <form #appointmentForm="ngForm" name="appointmentForm">
                        <div class="row">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card m-b-30">
                                        <div class="card-body">

                                            <!-- SEARCH PATIENT STARTS -->
                                            <form #appointmentForm="ngForm" name="appointmentForm">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h6 class="text-center">SEARCH BY PATIENT DETAILS</h6>
                                                    </div>
                                                </div><br>
                                                <div class="row">
                                                    <div class="col-lg-2">
                                                    </div>
                                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                        <input type="text" name="appointment['name']"
                                                            [(ngModel)]="appointment['name']" placeholder="Patient Name"
                                                            class="form-control select" />
                                                    </div>

                                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                        <input type="number" name="appointment['contact']"
                                                            class="form-control select" placeholder="Mobile No"
                                                            [(ngModel)]="appointment['contact']" />
                                                    </div>

                                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                        <input type="text" name="appointment['city']"
                                                            [(ngModel)]="appointment['city']" placeholder="Location"
                                                            class="form-control select" />
                                                    </div>


                                                    <div class="col-lg-1"></div>
                                                </div><br /><br />


                                                <div class="row">
                                                    <div class="col-lg-3 col-md-3"></div>



                                                    <div class="col-12">
                                                        <h6 class="text-center">SEARCH BY DATES</h6>
                                                    </div>

                                                    <div class="col-lg-3 col-md-3"></div>

                                                    <div class="d-flex col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                        <div class="dp-hidden position-absolute">
                                                            <div class="input-group">

                                                                <!-- <input name="datepicker" ngbDatepicker #datepicker="ngbDatepicker"
                                    (dateSelect)="onDateSelection($event)" [matDatepicker]="picker"> -->
                                                                <input name="datepicker" class="form-control"
                                                                    ngbDatepicker #datepicker="ngbDatepicker"
                                                                    [autoClose]="'outside'"
                                                                    (dateSelect)="onDateSelection($event, datepicker)"
                                                                    [displayMonths]="2" [dayTemplate]="t"
                                                                    outsideDays="hidden" [startDate]="fromDate!"
                                                                    tabindex="-1"
                                                                    style="border:1px solid white !important;" />
                                                                <ng-template #t let-date let-focused="focused">
                                                                    <span class="custom-day" [class.focused]="focused"
                                                                        [class.range]="isRange(date)"
                                                                        [class.faded]="isHovered(date) || isInside(date)"
                                                                        (mouseenter)="hoveredDate = date"
                                                                        (mouseleave)="hoveredDate = null">
                                                                        {{ date.day }}
                                                                    </span>
                                                                </ng-template>
                                                            </div>
                                                        </div>

                                                        <div class="input-group">
                                                            <input class="form-control" placeholder="From Date"
                                                                name="appointment['fromDate']"
                                                                [value]="formatter.format(fromDate)"
                                                                (input)="fromDate = validateInput(fromDate, appointment['fromDate'].value)" />

                                                            <button
                                                                class="btn btn-outline-secondary button-height calendar rounded-0"
                                                                (click)="datepicker.toggle()" type="button"><span
                                                                    class="fa fa-calendar"></span></button>
                                                        </div>

                                                    </div>


                                                    <div class="d-flex col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                        <div class="input-group">
                                                            <input class="form-control" placeholder="To Date"
                                                                name="appointment['toDate']"
                                                                [value]="formatter.format(toDate)"
                                                                (input)="toDate = validateInput(toDate, appointment['toDate'].value)" />
                                                            <button
                                                                class="btn btn-outline-secondary button-height calendar rounded-0"
                                                                (click)="datepicker.toggle()" type="button"><span
                                                                    class="fa fa-calendar"></span></button>
                                                        </div>
                                                    </div>


                                                    <div class="col-lg-3 col-md-3"></div>

                                                </div><br><br>


                                                <div class="row">
                                                    <div class="col-12 text-center">
                                                        <button type="submit" name="find"
                                                            class="btn btn-primary text-white btn-rounded"
                                                            (click)="fetchPatients(appointment)">FIND
                                                            PATIENT</button>&nbsp;&nbsp;
                                                        <button type="button" name="find"
                                                            class="btn btn-secondary text-white btn-rounded"
                                                            (click)="refresh(appointment)">Reset</button>
                                                    </div>
                                                </div>
                                            </form>


                                            <div *ngIf="isLoading">
                                                <appLoader [size]="small" [display]="isLoading" [screen]="container"
                                                    style="z-index: 1000;">
                                                </appLoader>
                                            </div>

                                            <br><br><br>

                                            <div class="row" *ngIf="pdata?.length > 0">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12"
                                                    *ngFor="let pat of pdata">

                                                    <!-- <div style="text-align: center;">
                                                        <img [src]="pat?.ppurl" class="image">
                                                    </div> -->

                                                    <div *ngIf="pat.avatarimg !='img_avatar.png'"
                                                        style="text-align: center;">
                                                        <img [src]="pat.ppurl" class="image">
                                                    </div>

                                                    <div class="profileImage" style="text-align: center;"
                                                        *ngIf="pat.avatarimg =='img_avatar.png'">

                                                        <avatar text={{pat?.name}} hash={{pat?.name}}></avatar>

                                                    </div>

                                                    <div class="user_card">
                                                        <div class="row">
                                                            <div class="col-5">
                                                                <label class="label1">Name:</label>
                                                            </div>
                                                            <div class="col-7">
                                                                <label class="label2">{{pat?.first_name}}
                                                                    {{pat?.last_name}}</label>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-5">
                                                                <label class="label1">Patient ID:</label>
                                                            </div>
                                                            <div class="col-7">
                                                                <label class="label2">{{pat?.pid}}</label>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-5">
                                                                <label class="label1">DOB:</label>
                                                            </div>
                                                            <div class="col-7">
                                                                <label class="label2">{{pat?.dob |
                                                                    date:'dd-MM-yyyy'}}</label>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-5">
                                                                <label class="label1">Gender:</label>
                                                            </div>
                                                            <div class="col-7">
                                                                <label class="label2">{{pat?.gender}}</label>
                                                            </div>
                                                        </div>



                                                        <div class="row">
                                                            <div class="col-5">
                                                                <label class="label1">Address:</label>
                                                            </div>
                                                            <div class="col-7">
                                                                <label class="label2">{{pat?.city_n}}</label>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-5">
                                                                <label class="label1">Contact:</label>
                                                            </div>
                                                            <div class="col-7">

                                                                <label class="label2">{{pat?.contact_no}}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 button">
                                                        <button type="button"
                                                            class="btn btn-primary form-control text-white"
                                                            id="{{pat?.pid}}"
                                                            (click)="patientSelection(pat['pid'])">{{selectButtonName}}</button>
                                                    </div><br>
                                                </div>
                                            </div>
                                            <!-- SEARCH PATIENT ENDS -->
                                        </div>

                                    </div><br><br><br><br><br><br><br><br><br><br><br><br>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end container-->